import { render, staticRenderFns } from "./ClassicAntimatterGalaxyRow.vue?vue&type=template&id=27e31a10&scoped=true&"
import script from "./ClassicAntimatterGalaxyRow.vue?vue&type=script&lang=js&"
export * from "./ClassicAntimatterGalaxyRow.vue?vue&type=script&lang=js&"
import style0 from "./ClassicAntimatterGalaxyRow.vue?vue&type=style&index=0&id=27e31a10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e31a10",
  null
  
)

export default component.exports